import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const ROLE_CLS = { admin: "role-admin", reviewer: "role-reviewer", readonly: "role-readonly" };
const inputCls = "mt-1 w-full bg-slate-950/60 border border-slate-800 rounded-md px-3 py-2 text-slate-100";
const primaryBtn = "bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold px-4 py-2 rounded-md text-sm";
const RoleOptions = () => <><option value="admin">Admin</option><option value="reviewer">Reviewer</option><option value="readonly">Read-Only</option></>;

export function MemberTable({ members, onRole, onReset, onRemove }) {
  return (
    <div className="sc-card overflow-hidden">
      <table className="sc-table w-full">
        <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Joined</th><th className="text-right">Actions</th></tr></thead>
        <tbody>
          {members.map((m) => (
            <tr key={m.membership_id} data-testid={`member-row-${m.id}`}>
              <td className="text-slate-100 font-semibold">{m.name}</td>
              <td className="text-slate-400">{m.email}</td>
              <td>
                <select value={m.role} onChange={(e) => onRole(m.membership_id, e.target.value)} className={`px-2 py-1 rounded text-xs font-mono uppercase font-bold ${ROLE_CLS[m.role]}`} data-testid={`role-select-${m.id}`}>
                  <RoleOptions />
                </select>
              </td>
              <td className="font-mono text-xs text-slate-500">{new Date(m.created_at).toLocaleDateString()}</td>
              <td className="text-right space-x-3">
                <button onClick={() => onReset(m)} className="text-amber-400 hover:text-amber-300 text-xs" data-testid={`reset-link-member-${m.id}`}>Reset link</button>
                <button onClick={() => onRemove(m.membership_id)} className="text-red-400 hover:text-red-300 text-xs" data-testid={`remove-member-${m.id}`}>Remove</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function ResetLinkDialog({ reset, onClose, onCopy }) {
  return (
    <Dialog open={!!reset} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-700 text-slate-100 max-w-lg">
        <DialogHeader><DialogTitle className="font-heading">Password reset link</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-300">One-time link for <span className="font-mono text-slate-100">{reset?.email}</span>. Share it securely; it expires in 30 minutes.</p>
        <div className="bg-slate-950/60 border border-slate-800 rounded-md p-3 text-xs font-mono break-all text-amber-300" data-testid="admin-reset-link-url">{reset?.url}</div>
        <DialogFooter>
          <button onClick={onClose} className="px-3 py-2 text-sm text-slate-400 hover:text-slate-200">Close</button>
          <button onClick={onCopy} className={primaryBtn} data-testid="admin-reset-link-copy">Copy link</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function AddMemberDialog({ open, onOpenChange, form, setForm, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader><DialogTitle className="font-heading">Add member</DialogTitle></DialogHeader>
        <label className="block"><span className="label-cap">Email</span>
          <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} data-testid="add-member-email" /></label>
        <label className="block"><span className="label-cap">Role</span>
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className={inputCls} data-testid="add-member-role"><RoleOptions /></select></label>
        <DialogFooter>
          <button onClick={() => onOpenChange(false)} className="px-3 py-2 text-sm text-slate-400 hover:text-slate-200">Cancel</button>
          <button onClick={onSubmit} className={primaryBtn} data-testid="add-member-submit">Add</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function InviteCreatedDialog({ invited, onClose }) {
  return (
    <Dialog open={!!invited} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader><DialogTitle className="font-heading">Invite created</DialogTitle></DialogHeader>
        <div className="text-sm text-slate-300">Share these credentials with <b>{invited?.email}</b>:</div>
        <div className="bg-slate-950/60 border border-slate-800 rounded-md p-3 font-mono text-xs">
          <div>Email: {invited?.email}</div>
          <div>Temp password: <span className="text-amber-400">{invited?.temp_password}</span></div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
